module.exports = __webpack_public_path__ + "static/media/fontext_4.44fa0c12.ico";